import React from 'react'

const ViewItemDetailsContext = React.createContext()

export default ViewItemDetailsContext
